import * as React from "react";
import { UserRole } from "../../../../utils/types/user";
import BillersDashboard from "../../pages/Billers";
import OtherUsersDashboard from "../../pages/OtherUsers";
import { useDoesUserHaveRole } from "../../../../hooks/permissions";
import ProvidersDashboard from "../ProvidersDashboard/ProvidersDashboard";

export default function DashboardToDisplay() {
    const showProvidersDashboard = useDoesUserHaveRole([UserRole.PROVIDER]);
    const showBillersDashboard = useDoesUserHaveRole([
        UserRole.BILLER,
        UserRole.SUPPORT_GENERAL,
    ]);

    return (
        <>
            {showProvidersDashboard && <ProvidersDashboard />}
            {showBillersDashboard && <BillersDashboard />}
            {!showProvidersDashboard && !showBillersDashboard && (
                <OtherUsersDashboard />
            )}
        </>
    );
}
